import { Address, AddressType } from "../AddressTypes";

export enum AccessEnum {
  ADMIN = 4,
  MANAGER = 3,
  OPERATOR = 2,
  CUSTOMER = 1,
  UNVERIFIED = 0,
}
export enum StatusEnum {
  Enabmled = "Enabled",
  Disabled = "Disabled",
}
export type UserType = {
  id: number;
  created?: string;
  modified?: string;
  lastLogin?: string;
  lastActionDate?: string;
  email: string;
  invoiceEmail?: string;
  eanNumber?: string | null;
  initials?: string;
  defaultBillingAddress?: AddressType;
  defaultShippingAddress?: AddressType;
  status?: StatusEnum;
  firstName: string;
  lastName: string;
  accessLevel: AccessEnum;
  isEanValidChecksum?: boolean | null;
  isEanValidExternal?: boolean | null;
  isEanInvoiceDiff?: boolean | null;
};

export type CreateUserType = {
  firstName: string;
  lastName: string;
  email: string;
  address?: Address;
  shippingAddress?: Address;
  accessLevel?: AccessEnum;
  eanNumber?: string;
  initials?: string;
};

export type UserListType = {
  items: UserType[];
  page: number;
  pageSize: number;
  total: number;
};

// Invoice fields resolved from e-conomic for a single user (EE-205).
// Only returned on a 200; the endpoint answers 404 when nothing could be
// resolved (no billing CVR, no e-conomic match, or the lookup failed).
export type UserInvoiceInfoType = {
  customerNumber: number | null;
  name: string | null;
  invoiceEmail: string | null;
  paymentTermsNumber: number | null;
  paymentTermsName: string | null;
};
